import Form from 'mobx-react-form';
import plugins from './plugins';

const fields = {
    name: {
        label: 'Name',
        placeholder: 'Webhook Name',
        rules: 'string|required',
    },
    url: {
        label: 'Webhook URL',
        placeholder: 'Webhook URL',
        rules: 'string|required',
    },
    signatureSecret: {
        label: 'Signature Secret( strongly recommended )',
        placeholder: 'Signature Secret',
        rules: 'string',
    },
    enabled: {
        label: 'Enabled',
        placeholder: 'Enabled',
        rules: 'boolean',
        type: 'checkbox',
    },
    type: {
        label: 'Webhook Type',
        placeholder: 'Webhook Type',
        rules: 'string|required',
        type: 'select',
        extra: [
            { value: 'all', label: 'All' },
            {
                value: 'hra-insights-completion',
                label: 'HRA Insights Completion',
            },
        ],
    },
};

class WebhookForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default WebhookForm;
